export enum TranslateLang {
    Ru = 'en-ru',
    En = 'ru-en',
}
